import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { MipAvatarModule } from '@libs/gc-common/lib/components/mip-avatar/mip-avatar.module';
import { MipIconModule } from '@libs/gc-common/lib/components/mip-icon/mip-icon.module';
import { MipProfileSlugNameModule } from '@libs/gc-common/lib/components/mip-profile-slug-name/mip-profile-slug-name.module';
import { PostViewModule } from '@libs/gc-common/lib/features/post-view/post-view.module';
import { MomentModule } from 'ngx-moment';
import { SwiperModule } from 'swiper/angular';

import { StoriesSliderComponent } from './stories-slider.component';

@NgModule({
  declarations: [StoriesSliderComponent],
  imports: [CommonModule, MipAvatarModule, MipProfileSlugNameModule, MomentModule, MatButtonModule, MipIconModule, MatRippleModule, RouterLink, PostViewModule, SwiperModule],
  exports: [StoriesSliderComponent]
})
export class StoriesSliderModule {

}
